<template>
  <div class="point-system-entry">
    <el-dialog
      title="科目分制录入"
      :visible.sync="pointSystemEntryShow"
      width="850px"
      :before-close="dialogClose"
      @open="dialogOpen"
    >
      <div style="margin-bottom: 20px">
        选择年级：
        <el-select
          v-model="selectGradeId"
          placeholder="选择年级"
          @change="pointEntryGradeChange"
        >
          <el-option
            :label="item.gradeName"
            :value="item.gradeId"
            v-for="item in gradeList"
            :key="item.gradeId"
          ></el-option>
        </el-select>
      </div>
      <div class="entry-list">
        <el-checkbox-group v-model="entryCheckList">
          <div
            class="entry-item"
            v-for="(item, index) in schoolCourseList"
            :key="index"
          >
            <el-checkbox
              :label="item.courseName"
              @change="checkboxChange($event, item)"
              v-model="item.checked"
            ></el-checkbox>
            <!-- 输入分制 -->
            <div class="item-input">
              <el-input
                type="number"
                v-model="item.fullScore"
                height="15"
                max="9999"
                min="1"
                placeholder="分制"
                placeholder-style="fontSize:12px"
                :clearable="false"
                :disabled="!item.checked"
                @input="scoreInput($event, item)"
              />
            </div>
          </div>
        </el-checkbox-group>
      </div>
      <div class="btn-list">
        <div class="btn define" @click="confirm">确定</div>
        <div class="btn cancel" @click="dialogClose">取消</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { nextTick } from "vue";
export default {
  props: ["pointSystemEntryShow", "schoolCourseList", "gradeList"],
  data() {
    return {
      entryCheckList: [], // 分制录入多选数据
      selectGradeId: "", // 选择的年级
    };
  },
  methods: {
    pointEntryGradeChange(e) {
      this.$emit("pointEntryGradeChange", e);
      this.entryCheckList = [];

      setTimeout(() => {
        // 如果科目列表中有checked为true的，则添加到entryCheckList中默认勾选
        this.schoolCourseList.forEach((item) => {
          if (item.checked) {
            this.entryCheckList.push(item.courseName);
          }
        });
      }, 500);
    },
    // 监听复选框的禁用情况
    checkboxChange(e, item) {
      if (e) {
        this.schoolCourseList.map((v) => {
          // 显示输入框
          if (v.courseName == item.courseName) {
            Vue.set(v, "checked", true);
          }
        });
      } else {
        // 取消勾选时，隐藏输入框，从科目数组中清空分制
        this.schoolCourseList.map((v, i, arr) => {
          if (v.courseName == item.courseName) {
            Vue.set(v, "checked", false);
            Vue.set(v, "fullScore", "");
            return;
          }
        });
      }
    },
    // 科目分制录入点击确定
    confirm() {
      let data = [];
      this.entryCheckList.forEach((item) => {
        this.schoolCourseList.forEach((sItem) => {
          if (item == sItem.courseName) {
            data.push({
              courseId: sItem.courseId,
              fullScore: sItem.fullScore,
            });
          }
        });
      });
      let confirmData = {
        schoolId: this.user.schoolId,
        gradeId: this.selectGradeId,
        courseList: data,
      };
      // console.log("科目分制录入点击确定", data);
      this.$emit("pointSystemEntryConfirm", confirmData);
    },
    dialogOpen() {
      // 打开时先清空一次，否则会遗留上次点击确认时的科目选中状态
      this.entryCheckList = [];
      this.selectGradeId = this.gradeList[0].gradeId;
      setTimeout(() => {
        // 如果科目列表中有checked为true的，则添加到entryCheckList中默认勾选
        this.schoolCourseList.forEach((item) => {
          if (item.checked) {
            this.entryCheckList.push(item.courseName);
          }
        });
      }, 500);
    },
    // 关闭弹出窗口
    dialogClose() {
      this.$emit("update:pointSystemEntryShow", false);
    },
    // 输入框失去焦点事件，value:默认值，即输入框内的值。item:整个item
    scoreInput(value, item) {
      // console.log("value", value)
      if (value > 9999) {
        item.fullScore = 9999;
      }
      if (value < 1) {
        item.fullScore = 1;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./pointSystemEntryDialog.scss";
</style>